import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators, compose } from 'redux';
import { intlShape } from 'react-intl';
import * as actions from './actions';
import { makeSelectRuleGenData } from './selector';
import './_ruleSummarize.scss';
import LocaleHoc from '../../LocaleHoc';
import * as constants from './constants';
import AiraContainer from '../UtilComponents/AiraContainer';
import CapIcon from '../../CapIcon';
import CapHeading from '../../CapHeading';
import MultiLineInputBox from '../UtilComponents/MultiLineInpuxBox';
import { MetaBlock } from './MetaBlock';
import Markdown from 'markdown-to-jsx';
import ErrorBar from '../UtilComponents/ErrorBar';
import messages from './messages';
import { AiraChatBot, AiraChatTitleBar } from '../UtilComponents/Icons';
import {
  getRuleApi,
  getRuleSummarizeApi,
  updateLikeResultApiRule,
  updateDislikeResultApiRule,
  updateDislikeResultApiSummarize,
  updateLikeResultApiSummarize,
} from './api';

const { RULE, SUMMARIZE, clsPrefix } = constants;

export const RuleSummarizationBot = ({
  actions,
  activity,
  getAPICallObject,
  request,
  askAiraData,
  iconPlacement,
  intl: { formatMessage },
}) => {
  const {
    getRuleStatus,
    getRuleError,
    ruleObj,
    getSummarizeStatus,
    explainObj,
    getSummarizeError,
  } = askAiraData;
  const [query, setQuery] = useState('');
  const [rule, setRule] = useState('');
  const [currentTab, setCurrentTab] = useState(RULE);
  const [likeRule, setLikeRule] = useState(0);
  const [likeSummarize, setLikeSummarize] = useState(0);

  const likeResp =  () => {
    if (currentTab === RULE) {
      setLikeRule(1);
      actions.updateLikeResultRule({
        updateLikeResultApiRule: updateLikeResultApiRule(request, getAPICallObject),
        requestId: ruleObj.requestId
      });
    } else if (currentTab === SUMMARIZE) {
      setLikeSummarize(1);
      actions.updateLikeResultSummarize({
        updateLikeResultApiSummarize: updateLikeResultApiSummarize(request, getAPICallObject),
        requestId: explainObj.requestId
      });
    }
  };

  const dislikeResp = async () => {
    if (currentTab === RULE) {
      setLikeRule(-1);
      actions.updateDislikeResultRule({
        updateDislikeResultApiRule: updateDislikeResultApiRule(request, getAPICallObject),
        requestId: ruleObj.requestId,
      });
    } else if (currentTab === SUMMARIZE) {
      setLikeSummarize(-1);
      actions.updateDislikeResultSummarize({
        updateDislikeResultApiSummarize: updateDislikeResultApiSummarize(request, getAPICallObject),
        requestId: explainObj.requestId,
      });
    }
  };
  const onSubmit = () => {
    setLikeRule(0);
    setLikeSummarize(0);
    if (currentTab === RULE) {
      actions.getRule({
        getRuleApi: getRuleApi(request, getAPICallObject),
        query: { activity, query },
      });
    } else if (currentTab === SUMMARIZE) {
      actions.getRuleSummarize({
        getRuleSummarizeApi: getRuleSummarizeApi(request, getAPICallObject),
        rule: { rule, activity },
      });
    }
  };

  const onHide = () => {
    setQuery('');
    setRule('');
    actions.resetRule();
  };

  const tabs = [
    { key: RULE, label: formatMessage(messages.textToExpression) },
    { key: SUMMARIZE, label: formatMessage(messages.expressionToText) },
  ];

  const ResponseWithIcon = ({ content, messageId }) => (
    <div style={{ display: 'flex', width: '90%' }}>
      <CapHeading style={{ marginRight: '0.60rem' }}>
        <CapIcon size="s" type="three-star-dark" className="chat-loader-icon" />
      </CapHeading>
      {content ? (
        <CapHeading className={`answer-received ${clsPrefix}-response`}>
          <Markdown>{content}</Markdown>
          <MetaBlock
            dislikeResp={dislikeResp}
            likeResp={likeResp}
            likeRule={likeRule}
            likeSummarize={likeSummarize}
            content={content}
            requestId={messageId}
            currentTab={currentTab}
          />
        </CapHeading>
      ) : (
        <CapHeading type="h6" style={{ display: 'flex', alignItems: 'center' }}>
          {formatMessage(messages.queryAnalysis)}
        </CapHeading>
      )}
    </div>
  );

const renderRuleContent = () => (
  <>
    <MultiLineInputBox
      value={query}
      setValue={setQuery}
      placeholder={formatMessage(messages.rulePlaceholder)}
      onSubmit={onSubmit}
      loading={getRuleStatus === constants.REQUEST}
    />
      <div className={`${clsPrefix}-content`}>
      {getRuleStatus === 'IDLE' &&
        !ruleObj?.rule && (
          <div className="rule-summarize-bot">
            <CapIcon
              type="three-star-dark"
              size="m"
              className="three-star-icon"
            />
            <CapHeading type="h4">
              {formatMessage(messages.airaTranslation)}
            </CapHeading>
            <CapHeading type="label4" className="rule-summarize-bot-desc">
              {formatMessage(messages.airaTranslationDescription)}
            </CapHeading>
          </div>
        )}
      {getRuleError && (
        <ErrorBar textError={formatMessage(messages.errorMessage)} />
      )}
      {ruleObj?.rule && (
        <ResponseWithIcon
          content={ruleObj?.rule}
          messageId={ruleObj?.requestId}
        />
      )}
      {getRuleStatus === constants.REQUEST &&
        !ruleObj?.rule && <ResponseWithIcon />}
    </div>
  </>
);

const renderRuleSummarizeContent = () => (
  <>
    <MultiLineInputBox
      value={rule}
      setValue={setRule}
      placeholder={formatMessage(messages.expressionPlaceholder)}
      onSubmit={onSubmit}
      loading={getSummarizeStatus === constants.REQUEST}
    />
      <div className={`${clsPrefix}-content`}>
      {getSummarizeStatus === 'IDLE' &&
        !explainObj?.explanation && (
          <div className="rule-summarize-bot">
            <CapIcon
              type="three-star-dark"
              size="m"
              className="three-star-icon"
            />
            <CapHeading type="h4">
              {formatMessage(messages.airaTranslation)}
            </CapHeading>
            <CapHeading type="label4" className="rule-summarize-bot-desc">
              {formatMessage(messages.summarizeTranslation)}
            </CapHeading>
          </div>
        )}
      {getSummarizeError && (
        <ErrorBar textError={formatMessage(messages.errorMessageSummarize)} />
      )}
      {explainObj?.explanation && (
        <ResponseWithIcon
          content={explainObj.explanation}
          messageId={explainObj.requestId}
        />
      )}
      {getSummarizeStatus === constants.REQUEST &&
        !explainObj?.explanation && <ResponseWithIcon />}
    </div>
  </>
);


  const renderTabContent = () => {
    switch (currentTab) {
      case RULE:
        return renderRuleContent();
      case SUMMARIZE:
        return renderRuleSummarizeContent();
      default:
        return null;
    }
  };

  return (
    <AiraContainer
      titlePadding="0.95rem"
      popupWidth="32rem"
      Icon={AiraChatBot}
      iconSize="1.5rem"
      iconProps={{
        svgProps: {
          style: {
            padding: 0
          }
        }
      }}
      title="Aira"
      onHide={onHide}
      iconPlacement={iconPlacement}
      titleBarIcon={AiraChatTitleBar}
      popupHeight="100vh"
      popupPlacement={{ type: 'float-br', padding: '0rem' }}
    >
      <div className={`${clsPrefix}-tabs-container`}>
        {tabs.map(tab => (
          <div
            key={tab.key}
            className={`${clsPrefix}-tab-item ${currentTab === tab.key ? 'active' : ''}`}
            onClick={() => setCurrentTab(tab.key)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div className={`${clsPrefix}-tab-content`}>{renderTabContent()}</div>
    </AiraContainer>
  );
};

RuleSummarizationBot.defaultProps = {
  askAiraData: {},
  intl: intlShape.isRequired,
};

const mapStateToProps = createStructuredSelector({
  askAiraData: makeSelectRuleGenData(),
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(
  LocaleHoc(RuleSummarizationBot, {
    key: 'CapAskAira.RuleSummarizationBot',
  }),
);
